// extracted by mini-css-extract-plugin
export var menuItem = "bc_y4 d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "bc_y5 d_Z d_bz d_bP";
export var menuMainLink = "bc_y6 d_f0 d_dB";
export var menuLink = "bc_y7 d_f0 d_dB";
export var icon = "bc_n9 d_bC d_bP";
export var divider = "bc_y8 d_bC d_bP";
export var sublinks = "bc_y9";
export var link = "bc_mC";
export var Link = "bc_tL y_tL y_sY y_th";